import { ContractAbi } from 'web3';
import {ContractAddress, TDepositForServer} from '../../../shared/api/contract';
import { MoonStaking } from '../../../shared/api/contract/ethers/moon-staking';
import { ConnectorType } from '@reown/appkit';
import i18n from "../../../i18n.ts";

export type StatusClaim = 'ok' | 'error';

export class ClaimService extends MoonStaking {
    constructor(contractAddress: ContractAddress, abi: ContractAbi, provider: ConnectorType, walletAddress: ContractAddress) {
        super(contractAddress, abi, provider, walletAddress);
    }

    async claim(indexes: bigint[], setMsg: (msg: string) => void): Promise<StatusClaim> {
        try {
            const gasEstimate = await this.contract.estimateGas.claimRewardsBatch(indexes);

            setMsg(i18n.t('approve_withdraw'));
            const tx = await this.contract.claimRewardsBatch(indexes, {
                gasLimit: gasEstimate.mul(110).div(100),
            });
            console.log(tx);
            setMsg(i18n.t('approve_rewards'));
            const receipt = await tx.wait();
            console.log(receipt);
            return 'ok';
        } catch (error) {
            console.log(error);

            return 'error';
        }
    }

    async saveRewards(deposits: TDepositForServer[]) {
        try {


            const response = await fetch(import.meta.env.VITE_DEPOSIT_API, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(deposits),
            });
        } catch (error) {
            console.log(error);
        }
    }
}
